import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider, ProtectedRoute, Login } from '@/auth'
import { Layout } from '@/components/layout'
import { Toaster } from '@/components/ui/toaster'
import { HomePage, SearchPage, DashboardPage, RequestAnalyticsPage, InfluencersPage, SettingsPage, InstagramAccountPage, GlobalAccountsPage, WatchlistsPage, CreateWatchlistPage, InstagramWatchlistPage, ChatPage, ConversationPage, SocialTrendsPage, GlobalTrendsPage, DeepIntelligencePage, PlaygroundPage, ShortsNarratorPage, SavedTrendsPage  } from '@/pages'
import { Routes, Route } from 'react-router-dom'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={
              <ProtectedRoute requireAuth={false}>
                <Login />
              </ProtectedRoute>
            } />
            
            {/* Protected routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout>
                  <HomePage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/search" element={
              <ProtectedRoute>
                <Layout>
                  <SearchPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/request-analytics" element={
              <ProtectedRoute>
                <Layout>
                  <RequestAnalyticsPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/saved-accounts" element={
              <ProtectedRoute>
                <Layout>
                  <InfluencersPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/watchlists" element={
              <ProtectedRoute>
                <Layout>
                  <WatchlistsPage />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/global-accounts" element={
              <ProtectedRoute>
                <Layout>
                  <GlobalAccountsPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/instagram/create-watchlist" element={
              <ProtectedRoute>
                <Layout>
                  <CreateWatchlistPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/instagram/watchlist/:uuid" element={
              <ProtectedRoute>
                <Layout>
                  <InstagramWatchlistPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <Layout>
                  <SettingsPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/instagram/account/:uuid" element={
              <ProtectedRoute>
                <Layout>
                  <InstagramAccountPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/chat" element={
              <ProtectedRoute>
                <Layout>
                  <ChatPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/chat/:conversationId" element={
              <ProtectedRoute>
                <Layout>
                  <ConversationPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/trends/social" element={
              <ProtectedRoute>
                <Layout>
                  <SocialTrendsPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/trends/global" element={
              <ProtectedRoute>
                <Layout>
                  <GlobalTrendsPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/trends/deep-intel" element={
              <ProtectedRoute>
                <Layout>
                  <DeepIntelligencePage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/playground" element={
              <ProtectedRoute>
                <Layout>
                  <PlaygroundPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/shorts-narrator" element={
              <ProtectedRoute>
                <Layout>
                  <ShortsNarratorPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/saved-trends" element={
              <ProtectedRoute>
                <Layout>
                  <SavedTrendsPage />
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster />
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  )
}

export default App 